import { render } from "./MerchantActivity.vue?vue&type=template&id=50402c2e&scoped=true"
import script from "./MerchantActivity.vue?vue&type=script&lang=js"
export * from "./MerchantActivity.vue?vue&type=script&lang=js"

import "./MerchantActivity.vue?vue&type=style&index=0&id=50402c2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50402c2e"]])

export default __exports__